import { ErrorLike } from "@apollo/client"
import { useQuery } from "@apollo/client/react"
import { FormValues } from "../CompleteConsents"
import { getGdprPreferencesQuery } from "../queries/getGdprPreferences"
import { getGdprPreferences } from "../queries/__generated-typings__/getGdprPreferences"

type UserConsentsResponse = {
  isUserWithoutConsents: boolean
  error: ErrorLike | undefined
  isError: boolean
  isLoading: boolean
  consents: FormValues | undefined
}

export const useUserConsents = (email: string): UserConsentsResponse => {
  const {
    data,
    error,
    loading: isLoading
  } = useQuery<getGdprPreferences>(getGdprPreferencesQuery, {
    variables: { email },
    skip: !email,
    fetchPolicy: "network-only"
  })

  const isError = (error && !error.message.toString().includes("404")) ?? false
  const isUserWithoutConsents = (error && error.message.toString().includes("404")) ?? false

  const consents = data?.getGdpr
    ? ({
        service: data.getGdpr.service,
        marketing: data.getGdpr.marketing,
        profiling: data.getGdpr.profiling,
        third_parties: data.getGdpr.third_parties,
        terms_and_conditions: data.getGdpr.terms_and_conditions
      } as FormValues)
    : undefined

  return {
    isUserWithoutConsents,
    error,
    isError,
    isLoading,
    consents
  }
}
